import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { AboutBodySection } from 'components/about/about-body-section.component';
import { useAboutCigna } from 'hooks/use-about-cigna.hook';
import { ABOUT_US_DESCRIPTION_TEXT } from 'common/constants';

const AboutCignaHealthcare = () => {
  const { formatMessage } = useIntl();
  const { handleGoBack } = useAboutCigna();

  useDocumentTitle(formatMessage({ id: 'STR_ABOUT' }));

  return (
    <MainPageContainer width="100%">
      <HeroSection
        title={formatMessage({ id: 'STR_ABOUT_CIGNA_HEALTHCARE' })}
        goBack={handleGoBack}
        height="140px"
      />
      <StackLayout
        css={{
          backgroundColor: '$surfaceCardSecondary',
          gap: '$half',
          padding: '$oneAndHalf',
          border: 'thin solid $onSurfaceBorderSubdued',
          borderRadius: '$medium',
          maxWidth: 1048,
          marginInlineStart: '$none',
          marginBottom: '$four',
          '@desktop': { marginInlineStart: '$three' },
        }}
      >
        <AboutBodySection htmlString={ABOUT_US_DESCRIPTION_TEXT} />
      </StackLayout>
    </MainPageContainer>
  );
};

export default AboutCignaHealthcare;
